const HK = {
  partnershipIncorporated: [
    "limited liability partnership (LP)"
  ],
  partnershipUnincorporated: [
    "general partnership",
    "limited partnership"
  ]
};
export {
  HK as default
};
